import cloneDeep from "lodash/cloneDeep";
import has from "lodash/has";

import { UPDATE_ACCOUNT_INFO, DECREASE_ACCOUNT_TOTAL_GOLD, DECREASE_ACTIVE_ENTRIES_COUNT, SYNC_CURRENT_ACCOUNT } from "../Actions/ActionAccount";

export const currentAccount = (state = {}, action) => {
  let totalGold = 0;
  let newState = null;
  let actionInfo = null;
  switch (action.type) {
    case SYNC_CURRENT_ACCOUNT:
      {
        return {
          ...state,
          supplyBuildings: action.payload.buildings
        };
      }
    case UPDATE_ACCOUNT_INFO:
      actionInfo = action.info;

      if (has(actionInfo, 'role')) {
        actionInfo = Object.assign({}, actionInfo, {
          roleName: actionInfo.role
        });
        delete actionInfo.role;
      }

      return Object.assign({}, state, actionInfo);
    case DECREASE_ACCOUNT_TOTAL_GOLD:
      totalGold = state.totalGold - action.amount;

      if (totalGold < 0) {
        totalGold = 0;
      }

      return Object.assign({}, state, {
        totalGold
      });
    case DECREASE_ACTIVE_ENTRIES_COUNT:
      newState = cloneDeep(state);

      if (newState.clanId && newState.activeApplicationsCount > 0) {
        newState.activeApplicationsCount--;
      } else if (newState.activeInvitesCount > 0) {
        newState.activeInvitesCount--;
      }

      return newState;
    default:
      return state;

  }
};